"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function MagnifyingGlass(props) {
    return (React.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 530 530" }, props),
        React.createElement("title", null, "icons8-search"),
        React.createElement("path", { d: "M198.75 44.166c-85.113 0-154.584 69.471-154.584 154.584s69.471 154.584 154.584 154.584c38.601 0 73.869-14.398 101.014-37.956l9.403 9.403v28.553l132.5 132.5 44.166-44.166-132.5-132.5H324.78l-9.403-9.403c23.558-27.145 37.956-62.412 37.956-101.014 0-85.113-69.471-154.584-154.584-154.584zm0 44.168c61.243 0 110.416 49.174 110.416 110.416S259.992 309.166 198.75 309.166c-61.243 0-110.416-49.174-110.416-110.416S137.508 88.334 198.75 88.334z" })));
}
exports.default = MagnifyingGlass;
//# sourceMappingURL=MagnifyingGlass.js.map